import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import './App.css'
import ComposedPage from './components/ComposedPage'

function App() {
  return (
    <Router>
      <Route path="/">
        <ComposedPage />
      </Route>
    </Router>
  )
}

export default App
